// extracted by mini-css-extract-plugin
module.exports = {"small":"index__small___1sQSd","expanded":"index__expanded___ZHxGA"};